module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.a011eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/fullscreen-image_lets-get_768.png
// module id = nACd
// module chunks = 0